import { render, staticRenderFns } from "./educationCourseDetail.vue?vue&type=template&id=6d422b06"
import script from "./educationCourseDetail.vue?vue&type=script&lang=js"
export * from "./educationCourseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d422b06')) {
      api.createRecord('6d422b06', component.options)
    } else {
      api.reload('6d422b06', component.options)
    }
    module.hot.accept("./educationCourseDetail.vue?vue&type=template&id=6d422b06", function () {
      api.rerender('6d422b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCourseDetail.vue"
export default component.exports